import * as React from "react";
import { ConfirmationModal } from "../UI/ConfirmationModal";
export const DeleteConfirmationModal = ({
  title,
  infoText,
  onClose,
  onConfirm = () => {},
}) => {
  return (
    <ConfirmationModal
      infoText={infoText}
      onClose={onClose}
      title={title}
      onConfirm={onConfirm}
    />
  );
};
